import {useEffect, useState} from 'react';
import {Alert, Box, Button, FormControlLabel, Stack, Switch, Typography} from '@mui/material';
import axios from 'axios';
import {useAuth} from '../context/AuthContext';
import config from '../config/config.json';

export default function AdsSettings() {
  const {token} = useAuth();
  const [enabled, setEnabled] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  useEffect(() => {
    let active = true;
    setLoaded(false);
    axios.get(`${config.api_base}/api/app-settings/admin`, {headers: {Authorization: `Bearer ${token}`}})
      .then(({data}) => {
        if (typeof data?.data?.adsEnabled !== 'boolean') throw new Error('Invalid settings');
        if (active) { setEnabled(data.data.adsEnabled); setLoaded(true); setError(''); }
      })
      .catch(() => { if (active) setError('Reklam ayarı alınamadı. Sayfayı yenileyerek tekrar deneyin.'); });
    return () => { active = false; };
  }, [token]);
  const save = async () => {
    setSaving(true); setError(''); setNotice('');
    try {
      const {data} = await axios.patch(`${config.api_base}/api/app-settings/admin`, {adsEnabled: enabled}, {headers: {Authorization: `Bearer ${token}`}});
      if (typeof data?.data?.adsEnabled !== 'boolean') throw new Error('Invalid settings');
      setEnabled(data.data.adsEnabled);
      setNotice(data.data.adsEnabled ? 'Reklamlar açıldı.' : 'Reklamlar kapatıldı.');
    } catch (_) { setError('Ayar kaydedilemedi. Tekrar deneyin.'); }
    finally { setSaving(false); }
  };
  return <Box sx={{backgroundColor: 'white', borderRadius: '16px', p: 3, border: '1px solid #E5E7EB'}}>
    <Stack spacing={2}>
      <Typography variant="h6">Google Reklamları</Typography>
      <Typography color="text.secondary">Banner ve tam ekran reklamlarını iOS ve Android için birlikte yönetin. Premium üyeler reklam görmez.</Typography>
      {error && <Alert severity="error">{error}</Alert>}
      {notice && <Alert severity="success">{notice}</Alert>}
      <FormControlLabel label={enabled ? 'Reklamlar açık' : 'Reklamlar kapalı'} control={<Switch checked={enabled} disabled={!loaded || saving} onChange={(_, value) => {setEnabled(value); setNotice('');}} />} />
      <Typography variant="body2" color="text.secondary">Değişiklik bu özelliği içeren uygulama sürümünde, uygulama açıldığında veya kullanım sırasında yaklaşık bir dakika içinde uygulanır. İnternet bağlantısı yoksa reklam gösterilmez.</Typography>
      <Button variant="contained" disabled={!loaded || saving} onClick={save} sx={{alignSelf: 'flex-start'}}>{saving ? 'Kaydediliyor…' : 'Reklam ayarını kaydet'}</Button>
    </Stack>
  </Box>;
}
